import { PlaceholderButton } from '@/shared/components/actions/placeholder-button';
import {
  Card,
  CardDescription,
  CardContent,
  CardTitle,
} from '@/shared/components/ui/card';

export const NoEntriesCardPlaceholder = ({
  title,
  description,
  children,
  action,
}: {
  title: string;
  description: string;
  children?: React.ReactNode;
  action?: () => void;
}) => {
  return (
    <Card
      className="h-64 shrink-0 items-center justify-center"
      variant="information"
    >
      <CardContent className="flex flex-col items-center justify-center space-y-4 text-center">
        <div className="space-y-2">
          <CardTitle className="text-lg">{title}</CardTitle>
          <CardDescription className="text-2xs text-white">
            {description}
          </CardDescription>
        </div>
        {children ?? <PlaceholderButton action={action} />}
      </CardContent>
    </Card>
  );
};
